export function normalizeText(value: string) {
  return value;
}

export function normalizeName(value: string) {
  let firstName = value.split(' ')[0];
  firstName = firstName.toLowerCase();
  const firstLetter = firstName.charAt(0).toUpperCase();
  return firstLetter + firstName.slice(1);
}

export const removeAccents = (value: string): string =>
  value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
